// extracted by extract-css-chunks-webpack-plugin
module.exports = {"expectfulLabel":"styles__expectfulLabel__3sX5z"};